import { StaffSelectionTiming, Strategy, Timing as LocationSelectionTiming } from '@wix/ambassador-bookings-v2-bookings-settings/types';
export const isMultiServiceAppointment = bookingsSettings => {
  var _bookingsSettings$mul;
  return !!((_bookingsSettings$mul = bookingsSettings.multiServiceAppointments) != null && _bookingsSettings$mul.enabled);
};
export const isStaffSelectionNotAllowed = bookingsSettings => {
  var _bookingsSettings$sta;
  return ((_bookingsSettings$sta = bookingsSettings.staffSelection) == null ? void 0 : _bookingsSettings$sta.strategy) === Strategy.CUSTOMER_CANNOT_CHOOSE;
};
export const isStaffSelectionAllowed = bookingsSettings => {
  return !isStaffSelectionNotAllowed(bookingsSettings);
};
export const isStaffSelectionMandatory = bookingsSettings => {
  var _bookingsSettings$sta2;
  return ((_bookingsSettings$sta2 = bookingsSettings.staffSelection) == null ? void 0 : _bookingsSettings$sta2.strategy) === Strategy.CUSTOMER_MUST_CHOOSE;
};
export const isStaffSelectionTimingNotDefined = bookingsSettings => {
  return !isStaffSelectionBeforeSlot(bookingsSettings) && !isStaffSelectionAfterSlot(bookingsSettings);
};
export const isStaffSelectionBeforeSlot = bookingsSettings => {
  var _bookingsSettings$sta3;
  return ((_bookingsSettings$sta3 = bookingsSettings.staffSelection) == null ? void 0 : _bookingsSettings$sta3.timing) === StaffSelectionTiming.BEFORE_SLOT_SELECTION;
};
export const isStaffSelectionAfterSlot = bookingsSettings => {
  var _bookingsSettings$sta4;
  return ((_bookingsSettings$sta4 = bookingsSettings.staffSelection) == null ? void 0 : _bookingsSettings$sta4.timing) === StaffSelectionTiming.AFTER_SLOT_SELECTION;
};
export const isLocationSelectionBeforeSlot = bookingsSettings => {
  var _bookingsSettings$loc;
  return ((_bookingsSettings$loc = bookingsSettings.locationSelection) == null ? void 0 : _bookingsSettings$loc.timing) === LocationSelectionTiming.BEFORE_SLOT_SELECTION;
};
export const isLocationSelectionAfterSlot = bookingsSettings => {
  var _bookingsSettings$loc2;
  return ((_bookingsSettings$loc2 = bookingsSettings.locationSelection) == null ? void 0 : _bookingsSettings$loc2.timing) === LocationSelectionTiming.AFTER_SLOT_SELECTION;
};
export const isLocationSelectionTimingNotDefined = bookingsSettings => {
  return !isLocationSelectionBeforeSlot(bookingsSettings) && !isLocationSelectionAfterSlot(bookingsSettings);
};
//# sourceMappingURL=bookingsSettings.js.map